import { Component } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';

@Component({
  selector: 'app-months',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './months.component.html',
  styleUrl: './months.component.scss'
})
export class MonthsComponent {
  months:any;
  currentPage=0;

  displayedColumns: string[] = [
    'actions','sno','months_name','is_active'
  ];

  constructor(private api: ApiService, private common: CommonService) { }

  ngOnInit(){
    this.month_list_in_admin_all_list()
  }

  // month_list() {
  //   this.api.get('settings/month_list').subscribe({
  //     next: (resp) => {
  //       if (resp.success) {
  //         this.months = resp.data
  //         console.log('Year list fetched', resp.data);
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error fetching year list:', err);
  //     }
  //   });
  // }

  month_list_in_admin_all_list() {
    this.api.get('settings/month_list_in_admin_all').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  change_status(month: any) {
    const payload = {
      id: month
    }
    this.api.post('settings/toggle_month_status',payload, true).subscribe({
      next: (resp) => {
        if (resp.success) {
          console.log('Status changed:', resp.data);
          this.month_list_in_admin_all_list(); // refresh list
        }
      },
      error: (err) => {
        console.error('Status update failed', err);
      }
    });
  }

  
  
}
